import { KDataTable } from "./KDataTable";

export default KDataTable.extend( {
	name: "KNestedErrorsTable",

	props: {
		hideDefaultFooter: {
			...KDataTable.options.props.hideDefaultFooter,
			default: true
		},

		items: {
			default: () => [],
			type: Array,
			validator: items =>
				items.every( item =>
					typeof item === "object"
						&& item.hasOwnProperty( "errorCount" )
						&& typeof item.errorCount === "number"
						&& item.hasOwnProperty( "errorType" )
						&& typeof item.errorType === "string"
						&& item.hasOwnProperty( "table" )
						&& typeof item.table === "object"
				)
		}
	},

	data: () => ( {
		defaultHeaders: [
			{
				divider: true,
				value: "data-table-expand",
				width: "1px"
			},
			{
				text: "Errors Associated with",
				value: "errorType"
			},
			{
				text: "Error Count",
				value: "errorCount"
			}
		]
	} ),

	render() {
		return <KDataTable
			attrs={this.$props}
			expandFlat
			headers={this.$_headers}
			itemKey="errorType"
			on={{ ...this.$listeners }}
			showExpand
			scopedSlots={{
				"expanded-item": ( { headers, item } ) =>
					<td colspan={headers.length}>
						{item.table}
					</td>,

				...this.$scopedSlots
			}}
		>
			<template slot="title">Errors</template>
		</KDataTable>;
	}
} );
